import { useNavigate } from 'react-router-dom';

import PageSecurity from '@/assets/mobile-encryption.png';
import { Button } from '@/@core';
import { PAGES, STATIC_PAGES } from '@/router/routeInitial.state';
import { useAuthenticate } from '@/context/AuthenticateContext';

export const NotFound = () => {
  const { isLoggedIn } = useAuthenticate();
  const navigate = useNavigate();

  const redirectTo = () => {
    if (!isLoggedIn) {
      navigate(STATIC_PAGES.SIGN_IN.path);
    } else {
      navigate(PAGES.API_CLIENTS.path);
    }
  };

  return (
    <div className="bg-[#ffffff] text-gray-500 dark:bg-zinc-800 dark:text-slate-300">
      <div className="mx-auto flex h-screen max-w-screen-sm flex-col items-center justify-center gap-4 text-center">
        <img src={PageSecurity} className="rounded-lg" />
        <h1 className="text-xs sm:text-xl">You do not have permissions, please try again.</h1>
        <Button onClick={redirectTo} color="primary">
          {!isLoggedIn ? 'Sign In' : 'Go Back'}
        </Button>
      </div>
    </div>
  );
};
